import PlatformNotice from './platform-notice';

export default PlatformNotice;
